import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { CertificationGroupType } from '@wix/wix-studio-marketplace-lib';
import {
  getCertificationGroupColor,
  getCertificationGroupLabel,
  CertificationGroupIcon,
  isCertificationGroup,
} from '../GroupedCertificationsUtils';

interface CompactCertificationProps {
  certificationGroup: CertificationGroupType;
}

const CompactCertification = ({
  certificationGroup,
}: CompactCertificationProps) => {
  const { t } = useTranslation();

  if (!isCertificationGroup(certificationGroup)) {
    return null;
  }

  const color = getCertificationGroupColor(certificationGroup);
  const labelKey = getCertificationGroupLabel(certificationGroup);

  return (
    <Box
      direction="horizontal"
      gap="3px"
      width="fit-content"
      padding="3px 12px 3px 6px"
      backgroundColor={color}
      style={{
        borderRadius: '1000px',
      }}
      dataHook={`certification-badge-${certificationGroup}`}
    >
      <CertificationGroupIcon />
      <Text size="small" style={{ color: '#000624' }}>
        {t(labelKey)}
      </Text>
    </Box>
  );
};

export default CompactCertification;
